import { path } from 'ramda'
import { createSelector } from 'reselect'

const getOrganizations = state => state.easymsOrganizations

export const selectEasymsOrganizations = createSelector(
    getOrganizations,
    organizations => path(['entities', 'organizations'], organizations) || {}
)

export const selectEasymsOrganizationsKV = createSelector(getOrganizations, organizations => {
    const organizationsData = path(['entities', 'organizations'], organizations)

    if (organizationsData)
        return organizations.result.map(organizationId => ({
            value: organizationId,
            label: `${organizationsData[organizationId].name} (id: ${organizationId})`
        }))
    return []
})


// WEBPACK FOOTER //
// ./src/selectors/easymsOrganizationSelector.js